
import introJs from "intro.js"
import('intro.js/introjs.css')

export default function UserGuideController(){
    let introjs,current_step
    this.generate = () =>{
        introjs = introJs().setOptions({
            nextLabel: "Próximo",
            prevLabel: "Voltar",
            doneLabel: "Finalizar",
            hidePrev: true,
            showProgress:true,
            showBullets: false,
            exitOnOverlayClick:false,
            showStepNumbers:false,
            stepNumbersOfLabel: "de",//of default
            autoPosition:true,
            steps: [{
              title: 'INTRODUÇÃO AO PRODUTO CHUVA',
              intro: 'Boas notícias! Agora você pode consultar facilmente dados pluviométricos/fluviométricos de todo o estado de SP. Você também poderá verificar a média histórica dos postos, comparar seu comportamento com anos anteriores, além de ferramentas para ajudar na análise dos dados'
            },
            {
              element: $('g .leaflet-interactive')[0],
              title: "MAPA - SELECIONAR POSTOS",
              intro: 'Primeiramente você deve <span class="emphasize">selecionar os postos</span> que deseja consultar os dados.'+
              '<br> Com o <span class="highlight">mapa interativo</span>, você consegue localizar postos perto de uma região de interesse sem a necessidade de saber nome/prefixo do posto. <br> Para selecionar, basta localizar e <span class="emphasize">clicar no icone</span> do posto no mapa',
              position: 'right',
            },
            {
              element: document.querySelector('.stations_button.leaflet-control'),
              title: "PAINEL POSTOS - SELECIONAR POSTOS",
              intro: 'Você também pode selecionar postos pelo <span class="highlight">painel postos</span>, que oferece a <span class="emphasize">lista com todos os postos disponíveis</span>. Você deve saber o <span class="emphasize">nome/prefixo do posto</span> para localizá-lo. <br> Você pode abrir o painel por esse botão:',
              position: 'right',
            },
            {
              title: 'PAINEL POSTOS - BUSCAR POSTO',
              element: document.querySelector('#search_container'),
              intro: 'O Painel postos possui as estações em forma de lista. <br> Você pode pesquisar os postos por <span class="emphasize">prefixo ou nome</span> através da <span class="highlight">Caixa de Pesquisa</span>',
              position:"right"
            },
            {
              title: 'PAINEL POSTOS - SELECIONAR POSTO',
              element: document.querySelector('.offcanvas-stations-list.offcanvas-stations-list-wrapper'),
              intro: 'Essa é a <span class="highlight">lista de postos</span>. Para selecionar, basta <span class="emphasize">clicar no item</span> referente ao posto desejado',
              position:"right"
            },
            {
              title: 'PAINEL POSTOS - GRUPO DE POSTOS',
              element: document.querySelector('#button_groups_container button'),
              intro: 'Você pode acessar <span class="emphasize">grupos de postos</span> personalizados pelo botão <span class="highlight">Grupo de postos</span>. Grupos facilitam na seleção de multíplos postos de uma só vez',
              position:"right"
            },
            {
              title: 'PAINEL POSTOS - BOTÕES AUXILIARES',
              element: document.querySelector('.stations-list-action-buttons-container'),
              intro: '<span class="emphasize">Limpar Seleções:</span> Tirar todas as seleções feitas até agora<br>'+
              '<span class="emphasize">Selecionados:</span> Exibir apenas postos selecionados na lista',
              position:"right"
            },
            {
              title: 'PAINEL OPÇÕES',
              element: document.querySelector('.config_button.leaflet-control'),
              intro: 'Após a seleção dos postos, você deve configurar os <span class="emphasize">opções de consulta</span> pelo <span class="highlight">painel opções</span>. Nele você define informações como <span class="emphasize">periodo, tipo de dados e tipo de transmissões.</span> <br> Você pode abrir o painel por esse botão:',
              position:"left"
            },
            {
                title: 'PAINEL OPÇÕES',
                element: document.querySelector('#offcanvas_options'),
                intro: 'Informe as <span class="emphasize">opções da sua consulta</span> no <span class="highlight">painel opções</span>.',
                position:"left"
            },
            {
                title: 'GERAR GRÁFICO',
                element: document.querySelector('.chart_button.leaflet-control'),
                intro: 'Após a definição dos postos/opções, é só <span class="emphasize">gerar a gráfico através do botão</span> gerar grafico',
                position:"left"
            },
            {
                title: 'FERRAMENTAS AUXILIARES - FILTRO',
                element: document.querySelector('.filter_button.leaflet-control'),
                intro: 'Você também tem a possibilidade de utilizar <span class="emphasize">ferramentas auxiliares</span> que facilitam na localizão/controle dos postos. <br>'+
                '<span class="highlight">Filtrar postos:</span> Possibilita o filtro de postos por <span class="emphasize">ugrhi, municipio, proprietário, entre outros</span>',
                position:"left"
            },
            {
                title: 'FERRAMENTAS AUXILIARES - CONTROLE DE CAMADAS',
                element: document.querySelector('.layer_button.leaflet-control'),
                intro: '<span class="highlight">Controle de camadas:</span> Possibilita <span class="emphasize">adicionar/configurar camadas</span> como limite municipal/limite estadual no mapa.<br>',
                position:"left"
            },
            {
                title: 'FERRAMENTAS AUXILIARES - LOCALIZAR COORDENADA',
                element: document.querySelector('.find-location-button.leaflet-control'),
                intro: '<span class="highlight">Localizar coordenada:</span> <span class="emphasize">Localiza</span> no mapa a <span class="emphasize">coordenada</span> informada. Também pode utilizar a sua <span class="emphasize">localização atual</span>.<br>',
                position:"left"
            },
            {
                title: 'AJUDA',
                element: document.querySelector('.help_button.leaflet-control'),
                intro: 'Para abrir novamente esse guia, basta clicar no botão ajuda',
                position:"left"
            }
            ]
          }).onbeforechange(async function(){
            
            const sleep = ms => new Promise(r => setTimeout(r, ms));
            if(this._currentStep == 1){
                $(document).trigger('map:zoom-to-markers')
                await sleep(200);
            }
            if([3,4,5,6].includes(this._currentStep)){ // step station start
                $(document).trigger('offcanvas-stations:open')
                await sleep(300);
            }
            if([2,7].includes(this._currentStep)){ // step station start
                $(document).trigger('offcanvas-stations:close')
                await sleep(300);
            }
            if(this._currentStep == 8){ // step station start
                $(document).trigger('offcanvas-options:open')
                await sleep(300);
            }
            if([7,9].includes(this._currentStep)){ // step station start
                $(document).trigger('offcanvas-options:close')
            }
          }).onchange(function(element){
            current_step = this._currentStep
          }).oncomplete(function(){
            localStorage.setItem('sibh_chart_user_guide', true);
          }).onexit(function(){
            localStorage.setItem('sibh_chart_user_guide', true);
          })
          if(!localStorage.getItem('sibh_chart_user_guide')){
            this.open()
          }
    } 

    this.open = () =>{
        // introjs.goToStep(9)
        introjs.start()
    }
}